// Gantt Page Component
import React from 'react';
import GanttChart from '../modules/gantt/GanttChart';

export const GanttPage: React.FC = () => {
  return <GanttChart />;
};

export default GanttPage;